import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';

import StatsService from '#services/StatsService';
import { updateStats } from '#store/stats';
import { balanceFormatter } from '#utils/balance-formatter';

import classes from './Stats.module.scss';

export const Stats = () => {
  const { t } = useTranslation();
  const statsInfo = useSelector((state) => state.stats.data);
  const { user } = useSelector((state) => state.userData);

  const dispatch = useDispatch();

  const isAdmin = user.role === 'admin';
  const isOperator = user.operator?.id;

  useEffect(() => {
    if (!isOperator) return;

    const getStatsInfo = async () => {
      try {
        const data = await StatsService.getStats();
        dispatch(updateStats(data));
      } catch (e) {
        console.log(e);
      }
    };

    getStatsInfo();
  }, [dispatch, isOperator, user.currency]);

  return statsInfo ? (
    <div className={classes.statsContainer}>
      <div className={classes.statsCard}>
        <div>{t('Receipts')}</div>
        <div>
          {balanceFormatter(statsInfo?.income?.amount)} {user.currency || 'UAH'}{' '}
          | {statsInfo.income.operations}
        </div>
      </div>
      <div className={classes.statsCard}>
        <div>{t('Payouts')}</div>
        <div>
          {balanceFormatter(statsInfo?.outcome?.amount)}{' '}
          {user.currency || 'UAH'} | {statsInfo.outcome.operations}
        </div>
      </div>
      <div className={classes.statsCard}>
        <div>{t('Balance')}</div>
        <div>
          {balanceFormatter(
            statsInfo?.paymentEntitiesInfo?.activePaymentEntitiesBalance
          )}{' '}
          {user.currency || 'UAH'}
        </div>
      </div>
      {isAdmin && (
        <div className={classes.statsCard}>
          <div>
            {t('Balance')} {isAdmin && '(' + t('active') + ')'}
          </div>
          <div>
            {balanceFormatter(
              statsInfo?.paymentEntitiesInfo
                ?.activeOperatorsPaymentEntitiesBalance
            )}{' '}
            {user.currency || 'UAH'}
          </div>
        </div>
      )}
    </div>
  ) : null;
};
